import { IGlobalState } from '../../../Root/store/appReducer'

export const getVerifyEmailLoading = (state: IGlobalState) => state.verifyEmail.loading
export const getVerifyEmailError = (state: IGlobalState) => state.verifyEmail.error
export const getVerifyEmailResending = (state: IGlobalState) => state.verifyEmail.resending
export const getVerifyEmailPurpose = (state: IGlobalState) => state.verifyEmail.purpose
export const getVerifyEmailEmail = (state: IGlobalState) => state.verifyEmail.email
